<template>
  <div class="partner-area pb-75">
    <div class="container mw-1356">
      <!-- عنوان فرعي اختياري لتوضيح طبيعة الشعارات -->
      <div class="section-title text-center mb-5" data-aos="fade-up" data-aos-duration="1000">
        <h5 class="text-secondary fw-bold">الخدمة متوافقة وتعمل على جميع الأنظمة والأجهزة</h5>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(brand, index) in supportedBrands"
          :key="brand.id"
          class="col-6 col-sm-4 col-md-3 col-xxl-2 text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="(index + 1) * 100"
        >
          <div class="partner-bg mb-4 d-flex align-items-center justify-content-center p-3">
            <img 
              :src="brand.image" 
              :alt="brand.name" 
              class="img-fluid" 
              style="max-height: 50px; filter: grayscale(100%); transition: filter 0.3s;"
              @mouseover="$event.currentTarget.style.filter = 'grayscale(0%)'"
              @mouseleave="$event.currentTarget.style.filter = 'grayscale(100%)'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PartnerLogo",
  setup() {
    // مصفوفة ديناميكية تمثل الأنظمة والشاشات لتسهيل إدارة الصور والتعديل عليها لاحقاً
    const supportedBrands = ref([
      { id: 1, name: "Android TV", image: require("@/assets/images/partner-1.png") },
      { id: 2, name: "Apple TV / iOS", image: require("@/assets/images/partner-2.png") },
      { id: 3, name: "Smart TV (Samsung/LG)", image: require("@/assets/images/partner-3.png") },
      { id: 4, name: "Amazon Fire Stick", image: require("@/assets/images/partner-4.png") },
      { id: 5, name: "Windows / PC", image: require("@/assets/images/partner-5.png") },
      { id: 6, name: "MAG / Enigma", image: require("@/assets/images/partner-6.png") },
    ]);

    return {
      supportedBrands,
    };
  },
});
</script>

<style scoped>
.partner-bg {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}
.partner-bg:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--bs-primary);
}
</style>